import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark'
    },
    typography: {
      fontFamily: 'Author',
    },
  });
export default theme;